import t from"../../../../utils/slug.js";const s=s=>{if((null==s?void 0:s.city)&&(null==s?void 0:s.state))return`${t(s.city)}:${s.state.toUpperCase()}`};export{s as default};
